import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

import { type AuthorizedSession, SystemSession } from '@mntn-dev/session/types'

export type SessionContextType = AuthorizedSession

export const SessionContext = createContext<SessionContextType>(SystemSession)
export const OptionalSessionContext = createContext<
  SessionContextType | undefined
>(undefined)

export const useSession = () => useContext(SessionContext)

export const useOptionalSession = () => useContext(OptionalSessionContext)

export const SessionProvider = ({
  session,
  children,
}: PropsWithChildren<{ session: AuthorizedSession }>) => (
  <SessionContext.Provider value={session}>
    <OptionalSessionContext.Provider value={session}>
      {children}
    </OptionalSessionContext.Provider>
  </SessionContext.Provider>
)
